var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClientActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1372_1043)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.7495 3.3125C9.19432 3.31241 7.67569 3.78399 6.39412 4.66498C5.11256 5.54597 4.12833 6.79493 3.57139 8.24696C3.01446 9.69898 2.91101 11.2858 3.2747 12.7978C3.6384 14.3099 4.45214 15.6761 5.60847 16.716C6.09076 15.767 6.82636 14.97 7.73377 14.4134C8.64118 13.8568 9.68497 13.5623 10.7495 13.5625C10.116 13.5625 9.49668 13.3746 8.96993 13.0227C8.44318 12.6707 8.03262 12.1705 7.79019 11.5852C7.54775 10.9999 7.48432 10.3558 7.60791 9.73448C7.7315 9.11313 8.03657 8.54239 8.48454 8.09442C8.9325 7.64646 9.50325 7.34139 10.1246 7.2178C10.7459 7.0942 11.39 7.15764 11.9753 7.40007C12.5606 7.64251 13.0608 8.05306 13.4128 8.57981C13.7648 9.10657 13.9526 9.72586 13.9526 10.3594C13.9526 11.2089 13.6151 12.0236 13.0144 12.6243C12.4137 13.225 11.599 13.5625 10.7495 13.5625C11.8139 13.5622 12.8577 13.8566 13.7651 14.4131C14.6725 14.9695 15.4081 15.7663 15.8905 16.7152C17.0465 15.6752 17.86 14.3091 18.2235 12.7972C18.5871 11.2853 18.4835 9.69866 17.9266 8.24682C17.3697 6.79497 16.3856 5.54614 15.1043 4.66519C13.8229 3.78424 12.3045 3.31259 10.7495 3.3125Z",
    fill: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 13.5625C12.519 13.5625 13.9531 12.1284 13.9531 10.3594C13.9531 8.59034 12.519 7.15625 10.75 7.15625C8.98096 7.15625 7.54688 8.59034 7.54688 10.3594C7.54688 12.1284 8.98096 13.5625 10.75 13.5625Z",
    stroke: "white",
    strokeWidth: 1.28125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6084 16.7142C6.0904 15.7648 6.82587 14.9674 7.7333 14.4104C8.64074 13.8534 9.68468 13.5586 10.7494 13.5586C11.8141 13.5586 12.8581 13.8534 13.7655 14.4104C14.673 14.9674 15.4084 15.7648 15.8904 16.7142",
    stroke: "white",
    strokeWidth: 1.28125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5938 5.23438H18.4375",
    stroke: "white",
    strokeWidth: 1.28125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5156 3.3125V7.15625",
    stroke: "white",
    strokeWidth: 1.28125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3309 9.71878C18.6011 11.3246 18.354 12.9748 17.6253 14.4311C16.8965 15.8873 15.7238 17.0743 14.2765 17.8206C12.8291 18.5669 11.182 18.8339 9.57303 18.583C7.96405 18.3322 6.47642 17.5764 5.32494 16.425C4.17347 15.2735 3.41775 13.7859 3.16689 12.1769C2.91603 10.5679 3.18303 8.92079 3.92932 7.47344C4.67561 6.02609 5.86257 4.85337 7.31883 4.12461C8.77509 3.39585 10.4253 3.14877 12.0311 3.41904",
    stroke: "white",
    strokeWidth: 1.28125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1372_1043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.5,
    height: 20.5,
    fill: "white",
    transform: "translate(0.5 0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientActive);
export default __webpack_public_path__ + "static/media/ClientActive.0e95bee5d78e11d63e4edda2aafe542b.svg";
export { ForwardRef as ReactComponent };